/* eslint-disable react/prop-types */
import { useState, useEffect } from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import ArgonAvatar from "components/ArgonAvatar";
import ArgonButton from "components/ArgonButton";
import { Link } from "react-router-dom";
import EditIcon from "@mui/icons-material/Edit";
import Switch from "@mui/material/Switch";
import axios from "utils/api";
import { baseURL } from "utils/api";

// Author component
function Author({ image, name, email }) {
  return (
    <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
      <ArgonBox mr={2}>
        <ArgonAvatar src={image} alt={name} size="sm" variant="lg" />
      </ArgonBox>
      <ArgonBox display="flex" flexDirection="column">
        <ArgonTypography variant="button" fontWeight="medium">
          {name}
        </ArgonTypography>
        <ArgonTypography variant="caption" color="secondary">
          {email}
        </ArgonTypography>
      </ArgonBox>
    </ArgonBox>
  );
}

const columns = [
  { name: "sno", align: "center" },
  { name: "fullName", align: "left" },
  { name: "email", align: "left" },
  { name: "password", align: "left" },
  { name: "isActive", align: "center" },
  { name: "action", align: "center" },
];

// Main hook for fetching sub-admins
const useSubAdminData = (handleStatusToggle, refresh, page = 1, limit = 10, search = "") => {
  const [userData, setUserData] = useState([]);
  const [userStatuses, setUserStatuses] = useState({});
  const [loading, setLoading] = useState(true);
  const [totalItems, setTotalItems] = useState(0);

  // Handler to update local state immediately
  const handleLocalToggle = (id, checked) => {
    setUserStatuses((prev) => ({
      ...prev,
      [id]: checked,
    }));
    handleStatusToggle(id, checked);
  };

  // Fetch user data
  useEffect(() => {
    setLoading(true);
    const params = new URLSearchParams({
      page: page.toString(),
      limit: limit.toString(),
    });
    if (search) {
      params.append("search", search);
    }
    axios
      .get(`${baseURL}/user?${params.toString()}`)
      .then((res) => {
        console.log("Response:", res.data);
        const data = res.data.data.users || [];
        const pagination = res.data.data.pagination || {};

        // Initialize user statuses
        const statuses = {};
        data.forEach((item) => {
          statuses[item._id] = item.isActive !== undefined ? item.isActive : true;
        });
        setUserStatuses(statuses);
        setUserData(data);
        setTotalItems(pagination.totalUsers || data.length);
      })
      .catch((err) => {
        console.error("❌ Error fetching subadmins:", err);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [refresh, page, limit, search]);

  // Format rows when userData or userStatuses change
  const rows = userData.map((item, index) => ({
    sno: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {(page - 1) * limit + index + 1}
      </ArgonTypography>
    ),
    fullName: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {item.fullName || "N/A"}
      </ArgonTypography>
    ),
    email: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {item.email}
      </ArgonTypography>
    ),
    password: (
      <ArgonTypography variant="caption" color="text" fontWeight="medium">
        {item.password || "N/A"}
      </ArgonTypography>
    ),
    isActive: (
      <ArgonBox display="flex" alignItems="center" justifyContent="center">
        <Switch
          checked={userStatuses[item._id] || false}
          onChange={(e) => handleLocalToggle(item._id, e.target.checked)}
          color="success"
          inputProps={{ "aria-label": "Active status toggle" }}
        />
      </ArgonBox>
    ),
    action: (
      <ArgonBox display="flex" alignItems="center" justifyContent="center" gap={1}>
        <Link to={`/subadmin/edituser/${item._id}`}>
          <ArgonButton variant="text" size="large" sx={{ minWidth: "12px", p: 0 }}>
            <EditIcon color="primary" />
          </ArgonButton>
        </Link>
      </ArgonBox>
    ),
  }));

  return { columns, rows, loading, totalItems };
};
export default useSubAdminData;

// eslint-disable react/prop-types
// Argon Dashboard 2 MUI components
// import ArgonBox from "components/ArgonBox";
// import ArgonTypography from "components/ArgonTypography";
// import ArgonAvatar from "components/ArgonAvatar";
// import ArgonBadge from "components/ArgonBadge";
// import DeleteIcon from '@mui/icons-material/Delete';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import { Button } from "@mui/material";
// import { Link } from "react-router-dom";
// import EditIcon from '@mui/icons-material/Edit';
// import { baseURL } from "utils/api";
// import axios from "utils/api"

// Images
// import team2 from "assets/images/team-2.jpg";
// import team3 from "assets/images/team-3.jpg";
// import team4 from "assets/images/team-4.jpg";
// import { useEffect } from "react";

// function Author({ image, name, email }) {

//   return (
//     <ArgonBox display="flex" alignItems="center" px={0.5} py={0.1}>
//       <ArgonBox mr={2}>
//         <ArgonAvatar src={image} alt={name} size="sm" variant="lg"/>
//       </ArgonBox>
//       <ArgonBox display="flex" flexDirection="column">
//         <ArgonTypography variant="button" fontWeight="medium">
//           {name}
//         </ArgonTypography>
//         <ArgonTypography variant="caption" color="secondary">
//           {email}
//         </ArgonTypography>
//       </ArgonBox>
//     </ArgonBox>
//   );
// }

// function Function({ job, org }) {
//   return (
//     <ArgonBox display="flex" flexDirection="column">
//       <ArgonTypography variant="caption" fontWeight="medium" color="text">
//         {job}
//       </ArgonTypography>
//       <ArgonTypography variant="caption" color="secondary">
//         {org}
//       </ArgonTypography>
//     </ArgonBox>
//   );
// }

// const subAdminData=  (handleDeleteClick)=>({
//   columns: [
//     {name:"sno",align:"center"},
//     {name:"profile",align:"left"},
//     {name:"Designation", align:"left"},
//     {name:"Phone_no",align:"left"},
//     {name:"action",align:"center"}

//     // {name:"sno",align:"center"},
//     // {name:"fullName",align:"left"},
//     // {name:"email",align:"left"},
//     // {name:"password",align:"left"},
//     // {name:"action",align:"center"}

//   ],

//   rows: [
//     {
//       sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">{1}</ArgonTypography>,
//       profile:<Author image={team3} name={"Meera joshi"} email={"meerajoshi@gmail.com"} />,
//       Designation: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Operations Head"}</ArgonTypography>,
//       Phone_no: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"7354722929"}</ArgonTypography>,
//        action: (
//              <ArgonBox display="flex" alignItems="center" gap={0}>
//                  {/* View Icon */}
//                   <Button variant="text"  size="large" component={Link} to="/subadmin/edituser" sx={{minWidth:"12px",p:0}} >
//                     <EditIcon color="primary"/>
//                   </Button>
//                   {/* Delete icon */}
//                  <Button variant="text"  size="large" sx={{minWidth:"32px",p:0}}
//                  onClick={() =>handleDeleteClick()} >
//                    <DeleteIcon color="error"/>
//                  </Button>

//                </ArgonBox>
//              ),
//     },
//     {
//       sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">{1}</ArgonTypography>,
//       profile:<Author image={team3} name={"Meera joshi"} email={"meerajoshi@gmail.com"} />,
//       Designation: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Operations Head"}</ArgonTypography>,
//       Phone_no: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"7354722929"}</ArgonTypography>,
//       action: (
//         <ArgonBox display="flex" alignItems="center" gap={1}>
//           {/* View Icon */}
//           <ArgonTypography  component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//             <VisibilityIcon/>
//           </ArgonTypography>

//           {/* Delete Icon */}
//           <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium" >
//             <DeleteIcon/>
//           </ArgonTypography>
//         </ArgonBox>
//       ),
//     },
//     {
//       sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">{2}</ArgonTypography>,
//       profile:<Author image={team3} name={"Meera joshi"} email={"meerajoshi@gmail.com"} />,
//       Designation: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Operations Head"}</ArgonTypography>,
//       Phone_no: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"7354722929"}</ArgonTypography>,
//       action: (
//         <ArgonBox display="flex" alignItems="center" gap={1}>
//           {/* View Icon */}
//           <ArgonTypography  component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//             <VisibilityIcon/>
//           </ArgonTypography>

//           {/* Delete Icon */}
//           <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium" >
//             <DeleteIcon/>
//           </ArgonTypography>
//         </ArgonBox>
//       ),
//     },
//     {
//       sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">{3}</ArgonTypography>,
//       profile:<Author image={team3} name={"Meera joshi"} email={"meerajoshi@gmail.com"} />,
//       Designation: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Operations Head"}</ArgonTypography>,
//       Phone_no: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"7354722929"}</ArgonTypography>,
//       action: (
//         <ArgonBox display="flex" alignItems="center" gap={1}>
//           {/* View Icon */}
//           <ArgonTypography  component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//             <VisibilityIcon/>
//           </ArgonTypography>

//           {/* Delete Icon */}
//           <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium" >
//             <DeleteIcon/>
//           </ArgonTypography>
//         </ArgonBox>
//       ),
//     },
//     {
//       sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">{4}</ArgonTypography>,
//       profile:<Author image={team3} name={"Meera joshi"} email={"meerajoshi@gmail.com"} />,
//       Designation: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Operations Head"}</ArgonTypography>,
//       Phone_no: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"7354722929"}</ArgonTypography>,
//       action: (
//         <ArgonBox display="flex" alignItems="center" gap={1}>
//           {/* View Icon */}
//           <ArgonTypography  component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//             <VisibilityIcon/>
//           </ArgonTypography>

//           {/* Delete Icon */}
//           <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium" >
//             <DeleteIcon/>
//           </ArgonTypography>
//         </ArgonBox>
//       ),
//     },
//     {
//       sno: <ArgonTypography variant="caption" color="text" fontWeight="medium">{5}</ArgonTypography>,
//       profile:<Author image={team3} name={"Meera joshi"} email={"meerajoshi@gmail.com"} />,
//       Designation: <ArgonTypography variant="caption" color="text" fontWeight="medium">{"Operations Head"}</ArgonTypography>,
//       Phone_no: <ArgonTypography variant="caption" fontWeight="medium" color="text">{"7354722929"}</ArgonTypography>,
//       action: (
//         <ArgonBox display="flex" alignItems="center" gap={1}>
//           {/* View Icon */}
//           <ArgonTypography  component="a" href="#" variant="body1" color="primary" fontWeight="medium">
//             <VisibilityIcon/>
//           </ArgonTypography>

//           {/* Delete Icon */}
//           <ArgonTypography component="a" href="#" variant="body1" color="error" fontWeight="medium" >
//             <DeleteIcon/>
//           </ArgonTypography>
//         </ArgonBox>
//       ),
//     },
//   ],
// });
// export default subAdminData;
